import type { Ref } from "vue";
import type { Requests } from "../common/request.common";
import type { WarehouseLocationResponseTypes } from "../common/response.common";
import type { SelectHook, SelectParam } from "../common/types.common";
import { asUpdateHook, buildSelectParam, get, post } from "./common";

export const warehouseLocation = {
    record(data: typeof Requests.WarehouseLocation.Record.Input) {
        return post<typeof data, WarehouseLocationResponseTypes.Record>(
            `/warehouse-location/record`,
            data,
        );
    },
    create(data: typeof Requests.WarehouseLocation.Create.Input) {
        return post<typeof data>(`/warehouse-location/create`, data);
    },
    obtain(id: string) {
        return get<WarehouseLocationResponseTypes.Obtain>(`/warehouse-location/obtain/${id}`);
    },
    formHooks: {
        select: (async (param?: SelectParam) => {
            const req = get<WarehouseLocationResponseTypes.Select>(
                `/warehouse-location/select` + buildSelectParam(param),
            );

            return (await req.execute()) ?? [];
        }) satisfies SelectHook,
        update(id: string, isLoading?: Ref<boolean>) {
            return async (data: typeof Requests.WarehouseLocation.Update.Input) => {
                return await asUpdateHook(
                    post<typeof data>(`/warehouse-location/update/${id}`, data),
                    isLoading,
                );
            };
        },
    },
};
